<template>
    <div style="display: inline-flex">

        <date-range-picker v-model="form" :disabled="loading" clearable start-placeholder="上线开始时间"
                           end-placeholder="上线结束时间" style="width:350px;margin-right: 3px"></date-range-picker>

        <el-select v-model="form.platform" :disabled="loading" placeholder="平台" filterable
                   style="width: 120px; margin-right: 3px">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
        </el-select>
        <el-select v-model="form.module" :disabled="loading" placeholder="模块" filterable
                   clearable style="width: 130px; margin-right: 3px" @change="init">
          <el-option v-for="(v, k) in image_module_map" :key="k" :label="v" :value="k"></el-option>
        </el-select>
        <el-select v-model="form.country" :disabled="loading" placeholder="全部国家" filterable clearable
                   style="margin-right: 3px">
            <el-option v-for="c in $root.country_list" :key="c.ip_name" :value="c.ip_name + ':' + c.code"
                       :label="c.en_name + ' (' + c.code + ')'"></el-option>
        </el-select>
        <el-select v-if="form.module === 'rookie'" v-model="form.label" :disabled="loading" placeholder="选择方案" @change="init" style="width: 120px" filterable clearable>
          <el-option v-for="l in [0, 1]" :value="l" :label="`方案${l}`"></el-option>
        </el-select>
        <el-select v-if="form.module === 'rookie'" v-model="form.day" :disabled="loading" placeholder="选择天数" @change="init" style="width: 120px" filterable clearable>
          <el-option v-for="d in Array.from({ length: 7 }, (_, i) => i )" :key="d" :value="d" :label="`第${d}天`"></el-option>
        </el-select>
        <el-select style="width: 160px; margin-right: 3px" placeholder="全部展示来源" filterable
                   v-model="form.source_remote" :disabled="loading" clearable @change="init">
          <el-option label="recommend" value="recommend"></el-option>
          <el-option label="normal" value="normal"></el-option>
          <el-option label="未记录" value="__empty__"></el-option>
        </el-select>
        <el-input style="width: 200px" placeholder="ID" v-model="form.id"
                  :disabled="loading"></el-input>
        <el-button type="primary" :disabled="loading" @click="init">查询</el-button>
    </div>
    <el-table :data="dataPage" v-loading="loading" style="margin-top: 20px" @sort-change="sortChange" :key="tableKey">
        <el-table-column label="ID" width="150" prop="image_id"></el-table-column>
        <el-table-column label="预览图" width="120">
            <template #default="scope">
                <el-image style="width: 100px" lazy
                          :src="`https://jigsaw-cdn.plutodesk.com/${scope.row.thumbnail}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="分类" width="120" prop="categories">
            <template #default="scope">
                <el-tag v-for="c in (scope.row.categories || [])" :key="c" size="small" style="margin: 2px;">
                    {{ categoryName(c) }}
                </el-tag>
            </template>
        </el-table-column>
        <el-table-column label="模块" width="140" prop="module">
            <template #default="scope">
                <el-tag v-for="m in moduleLabels(scope.row)" :key="m" size="small" style="margin: 2px;">
                    {{ m }}
                </el-tag>
            </template>
        </el-table-column>
        <el-table-column label="展示来源" width="120" prop="source_remote" sortable>
            <template #default="scope">
                {{ sourceRemoteLabel(scope.row.source_remote) }}
            </template>
        </el-table-column>
        <el-table-column label="表现分" width="110" prop="final_score" sortable>
            <template #default="scope">
                <el-tooltip v-if="scope.row.scoreDetail" placement="left" effect="dark">
                    <template #content>
                        <div class="score-detail-tooltip">
                            <div class="score-detail-row"><strong>表现分计算</strong></div>
                            <div class="score-detail-row">模型 = 平滑 + 标准化 + 展示量置信</div>
                            <div class="score-detail-row">权重 = {{ scope.row.scoreDetail.weights }}</div>
                            <div class="score-detail-row">K（展示中位数）= {{ scope.row.scoreDetail.K }}</div>
                            <div class="score-detail-row score-detail-divider">本行指标值（平滑后）</div>
                            <div class="score-detail-row">平滑进入率 = {{ percentText(scope.row.scoreDetail.smooth_enter_rate * 100) }}</div>
                            <div class="score-detail-row">平滑完成率 = {{ percentText(scope.row.scoreDetail.smooth_finish_rate * 100) }}</div>
                            <div class="score-detail-row">平滑分享率 = {{ percentText(scope.row.scoreDetail.smooth_share_rate * 100) }}</div>
                            <div class="score-detail-row">展示量置信 = {{ scope.row.scoreDetail.confidence.toFixed(2) }}</div>
                            <div class="score-detail-row score-detail-divider">各指标贡献</div>
                            <div v-for="(line, idx) in scope.row.scoreDetail.contributionLines" :key="idx" class="score-detail-row">{{ line }}</div>
                            <div class="score-detail-row">合计 = {{ scope.row.final_score.toFixed(2) }}</div>
                            <div class="score-detail-row score-detail-divider">等级划分</div>
                            <div class="score-detail-row">优秀 ≥ {{ scope.row.scoreDetail.thresholdHigh.toFixed(2) }}，糟糕 ≤ {{ scope.row.scoreDetail.thresholdLow.toFixed(2) }}</div>
                        </div>
                    </template>
                    <span class="score-cell-trigger">
                        <span>{{ scope.row.final_score.toFixed(2) }}</span>
                        <el-tag v-if="scope.row.quality_level === '优秀'" type="success" size="small" style="margin-left: 4px">优秀</el-tag>
                        <el-tag v-else-if="scope.row.quality_level === '糟糕'" type="danger" size="small" style="margin-left: 4px">糟糕</el-tag>
                        <el-tag v-else size="small" style="margin-left: 4px">普通</el-tag>
                    </span>
                </el-tooltip>
                <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column label="标准表现分" width="130" prop="standard_score" sortable>
            <template #default="scope">
                <el-tooltip v-if="scope.row.standardScoreDetail" placement="left" effect="dark">
                    <template #content>
                        <div class="score-detail-tooltip">
                            <div class="score-detail-row"><strong>标准表现分计算</strong></div>
                            <div class="score-detail-row">基准 = Android / United States / 2026-07-06 ~ 2026-08-04</div>
                            <div class="score-detail-row">0 表示接近 30 天总体平均</div>
                            <div class="score-detail-row">权重 = {{ scope.row.standardScoreDetail.weights }}</div>
                            <div class="score-detail-row">K（展示中位数）= {{ scope.row.standardScoreDetail.K }}</div>
                            <div class="score-detail-row score-detail-divider">本行指标值（平滑后）</div>
                            <div class="score-detail-row">平滑进入率 = {{ percentText(scope.row.standardScoreDetail.smooth_enter_rate * 100) }}</div>
                            <div class="score-detail-row">平滑完成率 = {{ percentText(scope.row.standardScoreDetail.smooth_finish_rate * 100) }}</div>
                            <div class="score-detail-row">平滑分享率 = {{ percentText(scope.row.standardScoreDetail.smooth_share_rate * 100) }}</div>
                            <div class="score-detail-row">展示量置信 = {{ scope.row.standardScoreDetail.confidence.toFixed(2) }}</div>
                            <div class="score-detail-row score-detail-divider">固定基准</div>
                            <div class="score-detail-row">进入率均值/标准差 = {{ percentText(scope.row.standardScoreDetail.mean_enter_rate * 100) }} / {{ percentText(scope.row.standardScoreDetail.std_enter_rate * 100) }}</div>
                            <div class="score-detail-row">完成率均值/标准差 = {{ percentText(scope.row.standardScoreDetail.mean_finish_rate * 100) }} / {{ percentText(scope.row.standardScoreDetail.std_finish_rate * 100) }}</div>
                            <div class="score-detail-row">分享率均值/标准差 = {{ percentText(scope.row.standardScoreDetail.mean_share_rate * 100) }} / {{ percentText(scope.row.standardScoreDetail.std_share_rate * 100) }}</div>
                            <div class="score-detail-row score-detail-divider">各指标贡献</div>
                            <div v-for="(line, idx) in scope.row.standardScoreDetail.contributionLines" :key="idx" class="score-detail-row">{{ line }}</div>
                            <div class="score-detail-row">合计 = {{ scope.row.standard_score.toFixed(2) }}</div>
                            <div class="score-detail-row score-detail-divider">等级划分</div>
                            <div class="score-detail-row">优秀 ≥ {{ scope.row.standardScoreDetail.thresholdHigh.toFixed(2) }}，糟糕 ≤ {{ scope.row.standardScoreDetail.thresholdLow.toFixed(2) }}</div>
                        </div>
                    </template>
                    <span class="score-cell-trigger">
                        <span>{{ scope.row.standard_score.toFixed(2) }}</span>
                        <el-tag v-if="scope.row.standard_quality_level === '优秀'" type="success" size="small" style="margin-left: 4px">优秀</el-tag>
                        <el-tag v-else-if="scope.row.standard_quality_level === '糟糕'" type="danger" size="small" style="margin-left: 4px">糟糕</el-tag>
                        <el-tag v-else size="small" style="margin-left: 4px">普通</el-tag>
                    </span>
                </el-tooltip>
                <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column label="激励" width="80" prop="level">
            <template #default="scope">
                {{ scope.row.cost ? '是' : '否' }}
            </template>
        </el-table-column>
        <el-table-column label="动图" width="80">
            <template #default="scope">
                {{ scope.row.animation ? '是' : '否' }}
            </template>
        </el-table-column>
        <el-table-column label="上线时间" width="140" prop="online_date" sortable></el-table-column>
        <el-table-column v-if="this.form.module==='rookie'" label="第几天" width="100" prop="day" sortable></el-table-column>
        <el-table-column label="展示" prop="impression" width="100" sortable></el-table-column>
        <el-table-column label="进入" prop="enter" width="100" sortable></el-table-column>
        <el-table-column label="进入率" prop="enter_rate" width="100" sortable>
            <template #default="scope">
                {{ percentText(scope.row.enter_rate) }}
            </template>
        </el-table-column>
        <el-table-column label="完成" prop="finish" width="100" sortable></el-table-column>
        <el-table-column label="完成率" prop="finish_rate" width="100" sortable>
            <template #default="scope">
                {{ percentText(scope.row.finish_rate) }}
            </template>
        </el-table-column>
        <el-table-column label="分享" prop="share" width="100" sortable></el-table-column>
        <el-table-column label="分享率" prop="share_rate" width="100" sortable>
            <template #default="scope">
                {{ percentText(scope.row.share_rate) }}
            </template>
        </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: center">
        <el-pagination v-model:current-page="page" :page-size="size" layout="prev, pager, next"
                       :total="dataFilter.length"></el-pagination>
    </div>
</template>

<script>
import {timestampToDate} from "../libs/utils";
import axios from "ts-axios-new";
import DateRangePicker from "../base/DateRangePicker.vue";
import {getProduct, getProductList} from "../libs/app";

const STANDARD_PERFORMANCE_SCORE_BENCHMARK = {
    dateRange: '2026-07-06 ~ 2026-08-04',
    platform: 'android',
    country: 'United States',
    K: 225,
    enterK: 4,
    finishK: 3,
    globalEnterRate: 0.01858288835606974,
    globalFinishRate: 0.42667627944085235,
    globalShareRate: 0.04169803564747886,
    meanEnterRate: 0.01900718768463435,
    stdEnterRate: 0.01998526105248683,
    meanFinishRate: 0.5347176926104877,
    stdFinishRate: 0.14650298457822528,
    meanShareRate: 0.15287400393366504,
    stdShareRate: 0.11277660036591995,
};
const STANDARD_SCORE_THRESHOLD_HIGH = 0.5;
const STANDARD_SCORE_THRESHOLD_LOW = -0.6;

export default {
    name: "Metric",
  components: {DateRangePicker},
    data() {
        const now = Date.now();
        return {
            tableKey: 0,
            loading: false, data: [], page: 1, size: 50, image_list: [],
            category_list: [], category_map: {},
            image_module_map: {"library": '图库', "rookie": '手动新手图'},
            image_module_enum: {"LIBRARY": '图库', "COLLECTION": '集合', "DAILY": '每日', "EVENT": '运营活动'},
            form: {
                id: '',
                start: timestampToDate(now - 24 * 3600 * 1000 - 10 * 3600 * 1000),
                end: timestampToDate(now - 24 * 3600 * 1000 - 10 * 3600 * 1000),
                country: 'United States:US',
                platform: 'android',
                module: "library",
                source_remote: null,
                label: null,
                day: null,
            }
        }
    },
    methods: {
        init() {
            this.loading = true;
            let metricList = [];
            axios.all([
                axios.get(`/cms/v1/performance`, {params: this.form}).then(res => {
                    metricList = res.data.data.metricList.data || [];
                }),
                axios.get('/cms/v1/category').then(res => {
                    this.category_list = res.data.data.categoryList || [];
                    this.category_map = {};
                    this.category_list.forEach(c => {
                        this.category_map[c.id] = c.i18n_name?.ZH_HANS || c.name || c.key || c.id;
                    });
                }),
            ]).then(() => {
                this.data = this.processMetricList(metricList);
            }).finally(() => {
                this.loading = false;
            })
        },
        sourceRemoteValue(sourceRemote) {
            return sourceRemote == null || sourceRemote === '' ? '__empty__' : sourceRemote;
        },
        sourceRemoteMatches(row) {
            if (!this.form.source_remote) {
                return true;
            }
            return this.sourceRemoteValue(row.source_remote) === this.form.source_remote;
        },
        addMetric(target, row) {
            ['impression', 'enter', 'finish', 'share'].forEach(field => {
                target[field] = (Number(target[field]) || 0) + (Number(row[field]) || 0);
            });
        },
        mergeImageInfo(target, row) {
            const categories = new Set([...(target.categories || []), ...((Array.isArray(row.categories) && row.categories) || [])]);
            target.categories = Array.from(categories);
            target.modules = {...(target.modules || {}), ...(row.modules || {})};
            if (!target.module && row.module) {
                target.module = row.module;
            }
            ['thumbnail', 'cost', 'animation', 'online_date', 'day', 'level'].forEach(field => {
                if (target[field] == null && row[field] != null) {
                    target[field] = row[field];
                }
            });
        },
        finalizeMetricRow(row) {
            row.categories = Array.isArray(row.categories) ? row.categories : [];
            row.enter_rate = row.impression ? parseInt(row.enter / row.impression * 10000) / 100.0 : 0;
            row.finish_rate = row.enter ? parseInt(row.finish / row.enter * 10000) / 100.0 : 0;
            row.share_rate = row.finish ? parseInt(row.share / row.finish * 10000) / 100.0 : 0;
            return row;
        },
        percentText(value) {
            const numericValue = Number(value);
            if (Number.isNaN(numericValue)) {
                return '-';
            }
            return `${numericValue.toFixed(2)}%`;
        },
        median(values) {
            const sorted = values.filter(v => v != null && !isNaN(v) && v > 0).sort((a, b) => a - b);
            if (!sorted.length) return 0;
            const mid = Math.floor(sorted.length / 2);
            return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
        },
        mean(values) {
            return values.length ? values.reduce((a, b) => a + b, 0) / values.length : 0;
        },
        std(values, avg) {
            if (values.length <= 1) return 0;
            const variance = values.reduce((acc, x) => acc + (x - avg) ** 2, 0) / values.length;
            return Math.sqrt(variance) || 0;
        },
        clampRate(value) {
            const numericValue = Number(value);
            if (Number.isNaN(numericValue)) return 0;
            return Math.max(0, Math.min(numericValue, 1));
        },
        computeStandardPerformanceScore(row, weights) {
            const benchmark = STANDARD_PERFORMANCE_SCORE_BENCHMARK;
            const impression = Number(row.impression) || 0;
            const enter = Number(row.enter) || 0;
            const finish = Number(row.finish) || 0;
            const share = Number(row.share) || 0;
            const cappedFinish = Math.min(finish, enter);
            const cappedShare = Math.min(share, finish);
            const smoothEnterRate = this.clampRate((enter + benchmark.K * benchmark.globalEnterRate) / (impression + benchmark.K));
            const smoothFinishRate = this.clampRate((cappedFinish + benchmark.enterK * benchmark.globalFinishRate) / (enter + benchmark.enterK));
            const smoothShareRate = this.clampRate((cappedShare + benchmark.finishK * benchmark.globalShareRate) / (finish + benchmark.finishK));
            const confidence = Math.max(0, Math.min(Math.log10(impression + 1) / Math.log10(1000), 1));
            const metrics = [
                {
                    name: '平滑进入率',
                    value: smoothEnterRate,
                    avg: benchmark.meanEnterRate,
                    sigma: benchmark.stdEnterRate,
                },
                {
                    name: '平滑完成率',
                    value: smoothFinishRate,
                    avg: benchmark.meanFinishRate,
                    sigma: benchmark.stdFinishRate,
                },
                {
                    name: '平滑分享率',
                    value: smoothShareRate,
                    avg: benchmark.meanShareRate,
                    sigma: benchmark.stdShareRate,
                },
            ];
            let score = 0;
            const contributionLines = metrics.map((metric, index) => {
                const z = metric.sigma > 0 ? (metric.value - metric.avg) / metric.sigma : 0;
                const contribution = z * weights[index] * confidence;
                score += contribution;
                return `${metric.name}(${weights[index]}): ${contribution.toFixed(3)}`;
            });
            row.standard_score = score;
            row.standard_quality_level = score >= STANDARD_SCORE_THRESHOLD_HIGH
                ? '优秀'
                : score <= STANDARD_SCORE_THRESHOLD_LOW ? '糟糕' : '普通';
            row.standardScoreDetail = {
                K: benchmark.K,
                weights: weights.join(', '),
                smooth_enter_rate: smoothEnterRate,
                smooth_finish_rate: smoothFinishRate,
                smooth_share_rate: smoothShareRate,
                confidence,
                mean_enter_rate: benchmark.meanEnterRate,
                std_enter_rate: benchmark.stdEnterRate,
                mean_finish_rate: benchmark.meanFinishRate,
                std_finish_rate: benchmark.stdFinishRate,
                mean_share_rate: benchmark.meanShareRate,
                std_share_rate: benchmark.stdShareRate,
                thresholdHigh: STANDARD_SCORE_THRESHOLD_HIGH,
                thresholdLow: STANDARD_SCORE_THRESHOLD_LOW,
                contributionLines,
            };
        },
        computePerformanceScores(list) {
            if (!list || !list.length) return list || [];

            const rows = list.map(row => ({...row}));
            const sum = (key) => rows.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
            const sumImpression = sum('impression');
            const sumEnter = sum('enter');
            const sumFinish = sum('finish');
            if (sumImpression <= 0) {
                rows.forEach(row => {
                    row.final_score = null;
                    row.quality_level = null;
                    row.scoreDetail = null;
                    row.standard_score = null;
                    row.standard_quality_level = null;
                    row.standardScoreDetail = null;
                });
                return rows;
            }

            const K = this.median(rows.map(row => Number(row.impression) || 0)) || 1;
            const enterK = this.median(rows.map(row => Number(row.enter) || 0)) || Math.max(1, K / 10);
            const finishK = this.median(rows.map(row => Number(row.finish) || 0)) || Math.max(1, enterK / 2);
            const globalEnterRate = this.clampRate(sumEnter / sumImpression);
            const globalFinishRate = this.clampRate(rows.reduce((acc, row) => {
                return acc + Math.min(Number(row.finish) || 0, Number(row.enter) || 0);
            }, 0) / Math.max(sumEnter, 1));
            const globalShareRate = this.clampRate(rows.reduce((acc, row) => {
                return acc + Math.min(Number(row.share) || 0, Number(row.finish) || 0);
            }, 0) / Math.max(sumFinish, 1));

            rows.forEach(row => {
                const impression = Number(row.impression) || 0;
                const enter = Number(row.enter) || 0;
                const finish = Number(row.finish) || 0;
                const share = Number(row.share) || 0;
                const cappedFinish = Math.min(finish, enter);
                const cappedShare = Math.min(share, finish);
                row._smooth_enter_rate = this.clampRate((enter + K * globalEnterRate) / (impression + K));
                row._smooth_finish_rate = this.clampRate((cappedFinish + enterK * globalFinishRate) / (enter + enterK));
                row._smooth_share_rate = this.clampRate((cappedShare + finishK * globalShareRate) / (finish + finishK));
                row._confidence = Math.max(0, Math.min(Math.log10(impression + 1) / Math.log10(1000), 1));
            });

            const metricNames = ['平滑进入率', '平滑完成率', '平滑分享率'];
            const metrics = ['_smooth_enter_rate', '_smooth_finish_rate', '_smooth_share_rate'];
            const weights = [0.6, 0.3, 0.1];
            const stats = metrics.map(metric => {
                const values = rows.map(row => Number(row[metric]) || 0);
                const avg = this.mean(values);
                return {avg, sigma: this.std(values, avg)};
            });

            rows.forEach(row => {
                let rawScore = 0;
                const contributions = [];
                metrics.forEach((metric, index) => {
                    const value = Number(row[metric]) || 0;
                    const {avg, sigma} = stats[index];
                    const z = sigma > 0 ? (value - avg) / sigma : 0;
                    const contribution = z * weights[index] * row._confidence;
                    rawScore += contribution;
                    contributions.push(`${metricNames[index]}(${weights[index]}): ${contribution.toFixed(3)}`);
                });
                row.final_score = rawScore;
                row._contributionLines = contributions;
            });

            const scores = rows.map(row => row.final_score).filter(score => score != null && !isNaN(score));
            const sortedScores = scores.slice().sort((a, b) => a - b);
            const thresholdLow = sortedScores.length
                ? sortedScores[Math.max(0, Math.floor(0.05 * sortedScores.length) - 1)]
                : 0;
            const thresholdHigh = sortedScores.length
                ? sortedScores[Math.min(sortedScores.length - 1, Math.ceil(0.95 * sortedScores.length) - 1)]
                : 0;

            rows.forEach(row => {
                row.quality_level = row.final_score >= thresholdHigh ? '优秀' : row.final_score <= thresholdLow ? '糟糕' : '普通';
                row.scoreDetail = {
                    K,
                    weights: weights.join(', '),
                    smooth_enter_rate: row._smooth_enter_rate,
                    smooth_finish_rate: row._smooth_finish_rate,
                    smooth_share_rate: row._smooth_share_rate,
                    confidence: row._confidence,
                    contributionLines: row._contributionLines || [],
                    thresholdLow,
                    thresholdHigh,
                };
                this.computeStandardPerformanceScore(row, weights);
                delete row._smooth_enter_rate;
                delete row._smooth_finish_rate;
                delete row._smooth_share_rate;
                delete row._confidence;
                delete row._contributionLines;
            });

            return rows;
        },
        processMetricList(metricList) {
            const rows = (metricList || []).filter(d => this.sourceRemoteMatches(d));
            const grouped = {};
            rows.forEach(row => {
                const key = row.image_id;
                if (!grouped[key]) {
                    grouped[key] = {
                        ...row,
                        source_remote: this.form.source_remote ? row.source_remote : '__all__',
                        impression: 0,
                        enter: 0,
                        finish: 0,
                        share: 0,
                        categories: [],
                        modules: {},
                    };
                }
                this.mergeImageInfo(grouped[key], row);
                this.addMetric(grouped[key], row);
            });
            return this.computePerformanceScores(Object.values(grouped).map(row => this.finalizeMetricRow(row)));
        },
        categoryName(categoryId) {
            return this.category_map[categoryId] || categoryId;
        },
        sourceRemoteLabel(sourceRemote) {
            if (sourceRemote === '__all__') return '全部';
            if (sourceRemote == null || sourceRemote === '') return '未记录';
            return sourceRemote;
        },
        moduleText(module) {
            return this.image_module_enum[module] || module || '未设置';
        },
        getProductName(key) {
            const product = getProductList().find(p => p.key === key);
            return product ? product.name : key;
        },
        moduleLabels(row) {
            if (row.module) {
                return [this.moduleText(row.module)];
            }
            const modules = row.modules || {};
            const currentProduct = getProduct()?.key;
            if (currentProduct && modules[currentProduct]) {
                return [this.moduleText(modules[currentProduct])];
            }
            return Object.keys(modules).map(product => `${this.getProductName(product)}: ${this.moduleText(modules[product])}`);
        },
        sortChange({column, prop, order}) {
            this.tableKey++;
            if (prop) {
                this.data.sort(function (a, b) {
                    let aValue= a[prop];
                    let bValue= b[prop];
                    if(prop === 'online_date') {
                        aValue = new Date(aValue).getTime();
                        bValue = new Date(bValue).getTime();
                        aValue = isNaN(aValue) ? -Infinity : aValue;
                        bValue = isNaN(bValue) ? -Infinity : bValue;
                    } else if (['categories', 'module', 'source_remote'].includes(prop)) {
                        aValue = Array.isArray(aValue) ? aValue.join(',') : (aValue || '');
                        bValue = Array.isArray(bValue) ? bValue.join(',') : (bValue || '');
                        return order === 'descending' ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
                    } else {
                        aValue = parseFloat(aValue);
                        bValue = parseFloat(bValue);
                        aValue = isNaN(aValue) ? -Infinity : aValue;
                        bValue = isNaN(bValue) ? -Infinity : bValue;
                    }
                    return order === 'descending' ? (aValue < bValue ? 1 : -1) : (aValue < bValue  ? -1 : 1);
                })
            } else {
                this.data.sort(function (a, b) {
                    return b.final_score - a.final_score;
                })
            }
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        dataFilter() {
            return this.data.filter(d => {
                let valid = d.impression > 100;
                valid &= !this.form.id || (d.image_id + '').includes(this.form.id);
                return valid;
            })
        },
        dataPage() {
            return this.dataFilter.slice((this.page - 1) * this.size, this.page * this.size)
        }
    }
}
</script>

<style scoped>

.el-select {
  width: 200px;
}

.score-cell-trigger {
  cursor: help;
  border-bottom: 1px dashed #909399;
}

.score-detail-tooltip {
  max-width: 360px;
  line-height: 1.6;
}

.score-detail-tooltip .score-detail-row {
  white-space: nowrap;
}

.score-detail-tooltip .score-detail-divider {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

</style>
